import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AppCustomerUsers from "@/components/users/app-customer-users/AppCustomerUsers";

const AppCustomerUsersPage = () => {
  const { appId } = useParams();
  const { customerId } = useParams();
  const [customerName, setCustomerName] = useState<string>("");

  const handleCustomerLoaded = (name: string) => {
    setCustomerName(name);
  };

  return (
    <>
      <AppCustomerUsers
        ApplicationId={Number(appId)}
        CustomerId={Number(customerId)}
        ShowOnlyNewAppCustomerUserPanel={false}
        onCustomerLoaded={handleCustomerLoaded}
        breadcrumbTitle="Application | Customer | Users"
        breadcrumbSubtitle={
          customerName ? (
            <>
              Manage users for customer{" "}
              <strong style={{ fontWeight: "600" }}>{customerName}</strong>
            </>
          ) : (
            "Manage users for this application and customer"
          )
        }
        backPath={`/applications/${appId}/customers`}
      />
    </>
  );
};

export default AppCustomerUsersPage;
